/* eslint-disable react-hooks/exhaustive-deps */
import React, { useReducer } from 'react';
import { FeedReducer, FeedActionContext, FeedStateContext, FeedInitialState } from './FeedState';
import Config from '../../config';
import { FeedSync } from './FeedSync';
import { useFeedWorkerIntervalSync } from './hooks/useFeedWorkerIntervalSync';
import { useSubscribedSymbolsContext } from './context/DataFeedSymbolsContext';

export const Feed: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(FeedReducer, FeedInitialState);

  // Sync dashboard feedSyncIntervalMs setting to workers
  useFeedWorkerIntervalSync();

  return (
    <useSubscribedSymbolsContext.Provider>
      <FeedActionContext.Provider value={dispatch}>
        <FeedStateContext.Provider value={state}>
          {!(Config.perf && Config.perf.batchedQuotes) && <FeedSync />}
          {children}
        </FeedStateContext.Provider>
      </FeedActionContext.Provider>
    </useSubscribedSymbolsContext.Provider>
  );
};
